export default "__VITE_ASSET__DIedYD0z__"